import React from 'react'
import './Footer.css'
import logo from '../../assets/img/logo.jpeg'
import { faSquareFacebook, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer">
        <div>
          <p className='contact-text-co'>(+598) 91 035 434 | contacto@cfrestudio.com</p>
        </div>
        <div className="social-links">
          <a href="https://www.instagram.com/cfr.estudio" target="blank">
            <FontAwesomeIcon
              className="img-i"
              icon={faInstagram}
              style={{ color: "#f7f8f9" }}
            />
          </a>
          <a href="mailto:contacto@cfrestudio.com" target="blank">
            <FontAwesomeIcon
              className="img-i"
              icon={faEnvelope}
              style={{ color: "#f7f8f9" }}
            />
          </a>
          <a href="https://www.facebook.com/cfrestudio/" target="blank">
            <FontAwesomeIcon
              className="img-i"
              icon={faSquareFacebook}
              style={{ color: "#f7f8f9" }}
            />
          </a>
          <a href="https://wa.me/+59891035434" target="blank">
            <FontAwesomeIcon
              className="img-i"
              icon={faWhatsapp}
              style={{ color: "#f7f8f9" }}
            />
          </a>
        </div>
        <div className="logo-f">
          <img src={logo} alt="" />
        </div>
        <div className="legal-container">
          <p className="footer-legal">
            © 2024 CFR Estudio®. Marca registrada. Todos los derechos
            reservados. La información es propiedad de CFR Estudio®. Prohibido
            recolectar, reproducir y comercializar.
          </p>
          <a
            href="https://wa.me/+59894299470"
            target="blank"
            className="footer-legal last-p"
          >
            Designed by VPEX - Infrastructure & Development
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer